$(function()
{
    var _container = null;
    var _show = null;
    var _showTemplate = null;

    function copyToView(newsletter, isAnimate)
    {
        scrollToView();

        hideView(isAnimate);

        var html = _showTemplate;

        html = html.split('*|TITLE|*').join(newsletter.title);
        html = html.split('*|CONTENT|*').join(newsletter.content);
        html = html.split('*|PLACE|*').join(newsletter.place);
        html = html.split('*|DATE|*').join(newsletter.date);
        html = html.split('*|EDITOR|*').join(newsletter.editor);
        html = html.split('*|TRANSLATED|*').join(newsletter.translated);
        html = html.split('*|PHOTO|*').join(newsletter.photo);
        html = html.split('*|PICTURE|*').join(newsletter.picture);
        html = html.split('*|PICTURE_W|*').join(newsletter.picture_w);
        html = html.split('*|PICTURE_H|*').join(newsletter.picture_h);
        html = html.split('*|PICTURE_ALT|*').join(newsletter.picture_alt);

        _container.html(html);

        if (newsletter.picture == null) _container.find('.js__nl-picture').remove();

        showView(isAnimate);
    }

    function hideView(isAnimate)
    {
        if (isAnimate) {
            _container.slideUp();
        } else {
            _container.hide();
        }
    }

    function showView(isAnimate)
    {
        if (isAnimate) {
            _container.slideDown();
        } else {
            _container.show();
        }
    }

    function scrollToView()
    {
        rsScrollTo((_container.offset().top - 105 - 20), 500);
    }

    function init()
    {
        $('.js__nl-item').bind('click', function(e){
            e.preventDefault();

            copyToView(NEWSLETTERS[$(this).data('target')], true);
        });

        $('.js-custom-select').customSelect({
            checkInnerHeight: !0
        });
    }

    $(document).ready(function(){
        _container = $('.js__nl-show-container');
        _show = $('.js__nl-show');

        _show.hide();

        _showTemplate = $('.js__nl-show').html();

        init();

        if (OPEN_FIRST) {
            copyToView(NEWSLETTERS[0], false);
        }
    });
});